import { render, staticRenderFns } from "./PaymentToDetail.vue?vue&type=template&id=c2b2ec8a&scoped=true&"
import script from "./PaymentToDetail.vue?vue&type=script&lang=js&"
export * from "./PaymentToDetail.vue?vue&type=script&lang=js&"
import style0 from "./PaymentToDetail.vue?vue&type=style&index=0&id=c2b2ec8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b2ec8a",
  null
  
)

export default component.exports